// src/components/products/Table/ProductsTableColumns.jsx

const ProductsTableColumns = [
    { id: "cover_image", labelAr: "الصورة", labelEn: "Cover", sortable: false },
    { id: "title_ar", labelAr: "العنوان (عربي)", labelEn: "Title (Arabic)", sortable: true },
    { id: "title_en", labelAr: "العنوان (إنجليزي)", labelEn: "Title (English)", sortable: true },
    { id: "product_type", labelAr: "نوع المنتج", labelEn: "Product Type", sortable: true },
    { id: "category", labelAr: "التصنيف", labelEn: "Category", sortable: true },
    { id: "suppliers", labelAr: "الموردين", labelEn: "Suppliers", sortable: false }, 
    { id: "transportation", labelAr: "وسيلة النقل", labelEn: "Transportation", sortable: true },
];

export default ProductsTableColumns;
